import { render, staticRenderFns } from "./DepartmentFunctionSelection.vue?vue&type=template&id=65375cfb&"
import script from "./DepartmentFunctionSelection.vue?vue&type=script&lang=js&"
export * from "./DepartmentFunctionSelection.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentFunctionSelection.vue?vue&type=style&index=0&id=65375cfb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports